// stableSerialize: Deterministically serialize objects/arrays/primitives so that
// key generation for caches does not depend on insertion order of properties.
// It sorts object keys recursively.
export function stableSerialize(value: any): string {
  return JSON.stringify(sortValue(value));
}

function sortValue(val: any): any {
  if (Array.isArray(val)) {
    return val.map(sortValue);
  }
  if (val && typeof val === 'object' && Object.prototype.toString.call(val) === '[object Object]') {
    const out: Record<string, any> = {};
    Object.keys(val).sort().forEach(k => {
      const v = (val as any)[k];
      if (v === undefined) return; // skip undefined to keep key compact
      out[k] = sortValue(v);
    });
    return out;
  }
  return val;
}
